<template>
<div class="ckeditor">
  <textarea :id="id" :value="value"></textarea>
</div>

</template>
<script>
export default {
  props: {
    value: {
      type: String
    },
    id: {
      type: String,
      default: 'editor'
    },
    height: {
      type: String,
      default: '200px'
    },
    fullpage: {
      type: Boolean,
      default: true
    },
    allowedContent: {
      type: Boolean,
      default: true
    },
    toolbar: {
      type: Array,
      default: () => [{
        name: 'document',
        groups: ['mode', 'document', 'doctools']
      },
      {
        name: 'clipboard',
        groups: ['clipboard', 'undo']
      },
      {
        name: 'editing',
        groups: ['find', 'selection', 'spellchecker', 'editing']
      },
      {
        name: 'forms',
        groups: ['forms']
      },
        '/',
      {
        name: 'basicstyles',
        groups: ['basicstyles', 'cleanup']
      },
      {
        name: 'paragraph',
        groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph']
      },
      {
        name: 'links',
        groups: ['links']
      },
      {
        name: 'insert',
        groups: ['insert']
      },
        '/',
      {
        name: 'styles',
        groups: ['styles']
      },
      {
        name: 'colors',
        groups: ['colors']
      },
      {
        name: 'tools',
        groups: ['tools']
      },
      {
        name: 'others',
        groups: ['others']
      },
      {
        name: 'about',
        groups: ['about']
      }
      ]
    },
    language: {
      type: String,
      default: 'pl'
    },
    extraplugins: {
      type: String,
      default: ''
    }
  },
  beforeUpdate () {
    const ckeditorId = this.id

    if (this.value !== CKEDITOR.instances[ckeditorId].getData()) {
      CKEDITOR.instances[ckeditorId].setData(this.value)
    }
  },
  mounted () {
    const ckeditorId = this.id
    const ckeditorConfig = {
      toolbarGroups: this.toolbar,
      fullPage: this.fullpage,
      allowedContent: this.allowedContent,
      language: this.language,
      height: this.height,
      extraPlugins: this.extraplugins
    }

    CKEDITOR.replace(ckeditorId, ckeditorConfig)

    CKEDITOR.instances[ckeditorId].setData(this.value)
    CKEDITOR.instances[ckeditorId].on('change', () => {
      let ckeditorData = CKEDITOR.instances[ckeditorId].getData()
      if (ckeditorData !== this.value) {
        this.$emit('input', ckeditorData)
      }
    })
  },
  destroyed () {
    const ckeditorId = this.id

    if (CKEDITOR.instances[ckeditorId]) {
      CKEDITOR.instances[ckeditorId].destroy()
    }
  }
}

</script>
<style>
.ckeditor {
  width: 100%;
  clear: both;
}

</style>



// WEBPACK FOOTER //
// ckeditor.vue?731078d7